import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import LaunchIcon from '@mui/icons-material/Launch';

import { certifications } from '../data';

function Certifications() {
  return (
    <Box sx={{ py: 1 }}>
      <Box sx={{ mb: 3.5, textAlign: 'center' }}>
        <Typography variant="h5" component="h1" gutterBottom sx={{ fontWeight: 800, color: '#00a2ff', fontFamily: "'Share Tech Mono', monospace" }}>
          [ Security Credentials & Badges ]
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: '500px', mx: 'auto', fontSize: '0.85rem' }}>
          Professional validations in network defense, API penetration testing, cloud security, and automation scripts.
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {certifications.map((cert, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card 
              sx={{ 
                height: '100%', 
                display: 'flex', 
                flexDirection: 'column', 
                justifyContent: 'space-between',
                p: 1,
                border: '1px solid #1c2536',
                background: '#0d1017',
                '&:hover': {
                  borderColor: 'rgba(0, 162, 255, 0.3) !important',
                }
              }}
            >
              <CardContent sx={{ p: 1.5, pb: 1 }}>
                <Box sx={{ display: 'flex', gap: 1.2, alignItems: 'flex-start', mb: 1.5 }}>
                  <Box 
                    sx={{ 
                      p: 0.8, 
                      bgcolor: 'rgba(0, 162, 255, 0.08)', 
                      color: '#00a2ff', 
                      borderRadius: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <WorkspacePremiumIcon sx={{ fontSize: '1.2rem' }} />
                  </Box>
                  <Box>
                    <Typography gutterBottom variant="body2" component="h2" sx={{ fontWeight: 700, fontSize: '0.88rem', lineHeight: 1.2, color: '#ffffff', fontFamily: "'Share Tech Mono', monospace" }}>
                      {cert.title}
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {cert.tags.map((tag) => (
                    <Chip 
                      key={tag} 
                      label={tag} 
                      size="small" 
                      sx={{ 
                        bgcolor: 'rgba(0, 162, 255, 0.04)', 
                        color: '#9ca3af', 
                        fontSize: '0.65rem',
                        fontWeight: 600,
                        border: '1px solid rgba(255, 255, 255, 0.06)',
                        height: 16,
                        '& .MuiChip-label': { px: 0.6 }
                      }} 
                    />
                  ))}
                </Box>
              </CardContent>
              <Box sx={{ p: 1.5, pt: 0 }}>
                <Button 
                  variant="outlined" 
                  color="primary"
                  size="small" 
                  href={cert.link} 
                  target="_blank" 
                  fullWidth
                  endIcon={<LaunchIcon sx={{ fontSize: '0.75rem !important' }} />}
                  sx={{
                    py: 0.4,
                    fontSize: '0.72rem',
                    borderColor: 'rgba(0, 162, 255, 0.25)',
                    '&:hover': {
                      borderColor: '#00a2ff',
                      bgcolor: 'rgba(0, 162, 255, 0.06)'
                    }
                  }}
                >
                  Verify Badge
                </Button>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default Certifications;